// import { install } from '@zjf-mall/common-ui';
import Cookies from 'js-cookie';
// 通过加载器始终加载最新的 CommonUI
(function(){
  const style = document.createElement('style');
  //:where 优先级为 0 用于在自定义元素未加载时占位，加载后会被覆盖
  style.innerHTML = `
:where(zjf-header){
  height: 30px;
  display: block;
}
:where(zjf-nav){
  height: 40px;
  display: block;
}
`
  document.head.appendChild(style);


  const script = document.createElement('script');
  script.type = 'module';
  script.src = '//qiniu.zhaojiafang.com/data/upload/shop/common/package/npm-cdn/@zjf-mall/common-utils@latest/dist/scripts-loader.es.js';
  script.onload = () => {
    window.ZJFLibs.resolve('@zjf-mall/common-ui@latest').then((CommonUI)=>{
      CommonUI.install(`zjf-`, {
        platform: 'zjf',
        token: () => Cookies.get('zjf_token'),
        urlPrefix: process.env.APP_ENV,
      })
    })
  };
  document.body.appendChild(script);
})();



// WEBPACK FOOTER //
// ./src/common-loader.js